export default {
  tagline: 'Game keys, fairly delivered. Experience a new standard in digital distribution.',
  shop: 'Shop',
  legal: 'Legal',
  help: 'Help',
  catalog: 'Catalog',
  deals: 'Deals',
  terms: 'Terms',
  privacy: 'Privacy',
  cookies: 'Cookies',
  faq: 'FAQ',
  paymentMethods: 'Accepted payment methods',
  copyright: '© {year} GladKey. Game keys, fairly delivered.',
};
